import { render, staticRenderFns } from "./EntriesPage.vue?vue&type=template&id=54d8a7b3&scoped=true"
import script from "./EntriesPage.vue?vue&type=script&lang=js"
export * from "./EntriesPage.vue?vue&type=script&lang=js"
import style0 from "./EntriesPage.vue?vue&type=style&index=0&id=54d8a7b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8a7b3",
  null
  
)

export default component.exports